import {buildCommonGridActionTypes} from "./commonGridATBuilder";
import {buildCommonEditorActionTypes} from "./commonEditorATBuider";

export const COUPONS_GRID = buildCommonGridActionTypes('COUPONS');

export const COUPONS_EDITOR = buildCommonEditorActionTypes('COUPONS');
